const shipmentSurchargeResponseToShipmentSurchargeObject = (response) => ({
    id: response.id,
    integrationId: response.integration_id,
    externalOrderId: response.external_order_id,
    carrier: response.carrier,
    shipmentDate: response.shipment_date,
    addressCorrectionFee: response.address_correction_fee,
    carbonOffsetFee: response.carbon_offset_fee,
    carrierPackagingFee: response.carrier_packaging_fee,
    codFee: response.cod_fee,
    customsDutiesTaxesFee: response.customs_duties_taxes_fee,
    dangerousGoodsFee: response.dangerous_goods_fee,
    deliveryConfirmationFee: response.delivery_confirmation_fee,
    dasFee: response.das_fee,
    fuelSurcharge: response.fuel_surcharge,
    handlingFee: response.handling_fee,
    insuredValueFee: response.insured_value_fee,
    latePaymentFee: response.late_payment_fee,
    oversizeFee: response.oversize_fee,
    peakSurchargeFee: response.peak_surcharge_fee,
    residentialSurchargeFee: response.residential_surcharge_fee,
    saturdaySundayFee: response.saturday_sunday_fee,
    signatureRequiredFee: response.signature_required_fee,
    thirdPartyFee: response.third_party_fee,
    variousFee: response.various_fee,
    errorMessage: response.error_message,
});

export { shipmentSurchargeResponseToShipmentSurchargeObject };
